import { useHistory } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/** A durable result, dismissed only by the nonprofit. Stripe submission is not approval. */
export default function StripeSuccessScreen({ onContinue, paymentsEnabled = false, stripeApproved = false, reviewing = false }) {
  const history = useHistory();
  const title = paymentsEnabled ? 'Payments are enabled' : stripeApproved ? 'Activating payments in CharityStack' : reviewing ? 'Stripe is reviewing your information' : 'Your information has been submitted';
  const description = paymentsEnabled
    ? 'Your account can accept donations. Publish any draft forms before sharing them. You can check payout readiness in Payment account settings.'
    : stripeApproved
      ? 'Stripe has enabled payments. CharityStack is confirming activation automatically; publishing and sharing remain unavailable until that finishes.'
      : reviewing
        ? 'Stripe is verifying your information. You can keep building and previewing while you wait.'
        : 'We are checking whether Stripe needs anything else. Submission alone does not enable payments. You can keep building and previewing your forms.';
  return <div className="rounded-md border border-edge bg-paper-light p-5 text-center" role="status">
    <h3 className="text-base font-medium text-ink">{title}</h3>
    <p className="mt-2 text-sm leading-relaxed text-ink-secondary">{description}</p>
    <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
      <Button variant="neutral" size="workspace" onClick={() => { onContinue?.(); history?.push('/settings/compliance'); }}>View payment status</Button>
      <Button variant="primary" size="workspace" onClick={onContinue}>Done</Button>
    </div>
  </div>;
}
